import { FiltersGetPaymentReferenceReportType, FiltersGetPaymentReportType } from "../../types/Finance";
import { GetActiveDebtType, GetComplianceRateType, GetDebtDistributionByPaymentTypeType, GetDebtsByPeriodType, GetOverdueDebtsType, GetPaymentHistoryByStudentType, GetStudentsWithMostDelaysType, GetTotalLateFeesType, GetTotalPaymentsByPeriodType } from "../../types/FinanceReports";
import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { get } from "../../utils/axios-config";
import { REPORTS_GET_ACTIVE_DEBTS, REPORTS_GET_COMPLIANCE_RATE, REPORTS_GET_DEBT_DISTRIBUTION_BY_PAYMENT_TYPE, REPORTS_GET_DEBTS_BY_PERIOD, REPORTS_GET_OVERDUE_DEBTS, REPORTS_GET_PAYMENT_REFERENCE_STATUS, REPORTS_GET_PAYMENT_REPORT, REPORTS_GET_PAYMENTS_HISTORY_BY_STUDENT, REPORTS_GET_STUDENTS_WITH_MOST_DELAYS, REPORTS_GET_TOTAL_PAYMENTS_BY_PERIODS, REPORTS_GET_TOTALS_LATES_FEES, REPORTS_PAYMENT_REFERENCE } from "../../utils/constants";

export const getActiveDebts = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });

    const url = `${REPORTS_GET_ACTIVE_DEBTS}?${queryParams.toString()}`;
    return await get<PagedResultsType<GetActiveDebtType>>(url)
};

export const getDebtsByPeriod = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.StartDate ? { StartDate: data.StartDate  } : {}),
        ...(data?.EndDate ? { EndDate: data.EndDate  } : {}),

    });

    const url = `${REPORTS_GET_DEBTS_BY_PERIOD}?${queryParams.toString()}`;
    return await get<PagedResultsType<GetDebtsByPeriodType>>(url)
};

export const getOverdueDebts = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });

    const url = `${REPORTS_GET_OVERDUE_DEBTS}?${queryParams.toString()}`;
    return await get<PagedResultsType<GetOverdueDebtsType>>(url)
};

export const getDebtDistributionByPaymentType = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });

    const url = `${REPORTS_GET_DEBT_DISTRIBUTION_BY_PAYMENT_TYPE}?${queryParams.toString()}`;
    return await get<PagedResultsType<GetDebtDistributionByPaymentTypeType>>(url)
};

export const getPaymentsHistoryByStudent = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });

    const url = `${REPORTS_GET_PAYMENTS_HISTORY_BY_STUDENT}?${queryParams.toString()}`;
    return await get<PagedResultsType<GetPaymentHistoryByStudentType>>(url)
};

export const getTotalPaymentsByPeriods = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });

    const url = `${REPORTS_GET_TOTAL_PAYMENTS_BY_PERIODS}?${queryParams.toString()}`;
    return await get<PagedResultsType<GetTotalPaymentsByPeriodType>>(url)
};

export const getComplianceRate = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });

    const url = `${REPORTS_GET_COMPLIANCE_RATE}?${queryParams.toString()}`;
    return await get<GetComplianceRateType>(url)
};

export const getTotalsLatesFees = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });

    const url = `${REPORTS_GET_TOTALS_LATES_FEES}?${queryParams.toString()}`;
    return await get<PagedResultsType<GetTotalLateFeesType>>(url)
};

export const getStudentsWithMostDelays = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });

    const url = `${REPORTS_GET_STUDENTS_WITH_MOST_DELAYS}?${queryParams.toString()}`;
    return await get<PagedResultsType<GetStudentsWithMostDelaysType>>(url)
};

export const getPaymentReport = async (data: FiltersGetPaymentReportType) => {
    const queryParams = new URLSearchParams(
        Object.entries(data)
            .filter(([_, value]) => value !== undefined && value !== "")
            .reduce((acc, [key, value]) => {
                acc[key] = typeof value === "boolean" ? (value ? "1" : "0") : value.toString();
                return acc;
            }, {} as Record<string, string>)
    );
    const url = `${REPORTS_GET_PAYMENT_REPORT}?${queryParams.toString()}`;
    return await get<any>(url)
};


export const getPaymentReferenceReport  = async (data: FiltersGetPaymentReferenceReportType) => {
    const queryParams = new URLSearchParams(
        Object.entries(data)
            .filter(([_, value]) => value !== undefined && value !== "")
            .reduce((acc, [key, value]) => {
                acc[key] = typeof value === "boolean" ? (value ? "1" : "0") : value.toString();
                return acc;
            }, {} as Record<string, string>)
    );
    const url = `${REPORTS_GET_PAYMENT_REFERENCE_STATUS}?${queryParams.toString()}`;
    return await get<any>(url)
};

export const getPaymentReferenceReportAdvanced  = async (data: any) => {
    const queryParams = new URLSearchParams(
        Object.entries(data)
            .filter(([_, value]) => value !== undefined && value !== "")
            .reduce((acc, [key, value]) => {
                acc[key] = typeof value === "boolean" ? (value ? "1" : "0") : `${value}`;
                return acc;
            }, {} as Record<string, string>)
    );
    const url = `${REPORTS_PAYMENT_REFERENCE}?${queryParams.toString()}`;
    return await get<any>(url)
};